import { computed } from 'vue'
import { useOnboardingStore } from '../store/onboardingStore'

// True while the Sumsub SDK owns the whole viewport. Published for
// OnboardingLayout, which hides its footer strip during the SDK — the layout
// only needs this one flag, never the wizard store itself.
export function useIsKycSdkFullScreen() {
  const store = useOnboardingStore()
  return computed(() => store.currentStepKey === 'kyc_onfido' && store.identitySubStep === 'sdk')
}
